import Flickity from 'flickity';

export default (function() {
  'use strict';

  /* eslint-disable no-unused-vars */

  var sliders = document.querySelectorAll('.slider');
  // Define our viewportWidth variable

  function initCarouselContainer() {
    sliders.forEach(function(slider){
      var flkty = new Flickity(slider, {
        draggable: true,
        autoPlay: false,
        pageDots: true,
        prevNextButtons: false,
        wrapAround: true,
        contain: true,
        initialIndex: 1,
        watchCSS: true,
        prevNextButtons: true,
        arrowShape: {
          x0: 10,
          x1: 60, y1: 50,
          x2: 70, y2: 40,
          x3: 30
        },
        on: {
          ready: function() {
            this.element.classList.add('flickity-ready')
          }
        }
      });
    }
  )
}

  function init() {
    if(sliders) {

      initCarouselContainer();
    }
  }

  return {
    init: init
  };


  /* eslint-enable no-unused-vars */

})()
